import type { ReactNode } from 'react';
import { CircleAlert } from 'lucide-react';
import styles from './form.module.css';

export interface FieldProps {
  id: string;
  label: string;
  hint?: ReactNode;
  error?: string;
  /** Visually smaller "(opcjonalne)" marker next to the label. */
  optional?: boolean;
  children: ReactNode;
}

export const hintId = (id: string) => `${id}-hint`;
export const errorId = (id: string) => `${id}-error`;

export function describedBy(id: string, hint?: unknown, error?: unknown): string | undefined {
  const ids = [hint ? hintId(id) : '', error ? errorId(id) : ''].filter(Boolean);
  return ids.length ? ids.join(' ') : undefined;
}

export function Field({ id, label, hint, error, optional, children }: FieldProps) {
  return (
    <div className={styles.field}>
      <label htmlFor={id} className={styles.label}>
        {label}
        {optional && <span className={styles.optional}> (opcjonalne)</span>}
      </label>
      {hint && (
        <p id={hintId(id)} className={styles.hint}>
          {hint}
        </p>
      )}
      {children}
      {error && (
        <p id={errorId(id)} className={styles.error} role="alert">
          <CircleAlert aria-hidden="true" />
          {error}
        </p>
      )}
    </div>
  );
}
